import { Screenmode } from './screenmode'

export class InfoRequestOverlay {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        pageHeader: '.page-header',
        infoRequestTrigger: '.info-request-overlay-trigger',
        closeTrigger: '.info-request-overlay__close',
        infoRequestOverlay: '.info-request-overlay',
        mainNavigationClose: '.main-navigation__close'
      },
      classes: {
        infoRequestOverlayOpen: 'info-request-overlay--open',
        bodyNoScroll: 'is--no-scroll',
        bodyMobileNavigationOpen: 'is--open-mobile-navigation'
      },
      scrollingHeaderTop: {
        xs: 70,
        sm: 70,
        md: 115,
        lg: 150,
        xl: 150
      }
    },
    settings)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const that = this
    const infoRequestTrigger = $(that.options.selectors.infoRequestTrigger)
    const closeTrigger = $(that.options.selectors.closeTrigger)
    const infoRequestOverlay = $(that.options.selectors.infoRequestOverlay)
    let resizeTimer

    infoRequestTrigger
      .on({
        click: function (event) {
          event.preventDefault()

          if (infoRequestOverlay.hasClass(that.options.classes.infoRequestOverlayOpen)) {
            that.closeInfoRequestOverlay()
          } else {
            that.openInfoRequestOverlay()
          }

          return false
        }
      })

    closeTrigger
      .on({
        click: function (event) {
          that.closeInfoRequestOverlay()
        }
      })

    $(document)
      .on({
        keyup: function (event) {
          // Press "Escape"
          if (event.keyCode === 27) {
            that.closeInfoRequestOverlay()
          }

          // Tab
          if (event.originalEvent.keyCode === 9) {
            const focusedElement = $(this).find(':focus')

            const infoRequestOverlay = $(that.options.selectors.infoRequestOverlay)

            if (focusedElement.closest(that.options.selectors.infoRequestOverlay).length === 0) {
              if (infoRequestOverlay.hasClass(that.options.classes.infoRequestOverlayOpen)) {
                that.closeInfoRequestOverlay()
              }
            } else {
              if (!infoRequestOverlay.hasClass(that.options.classes.infoRequestOverlayOpen)) {
                that.openInfoRequestOverlay()
              }
            }
          }
        }
      })

    $(window)
      .resize(function () {
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(function () {
          let infoRequestLayerTop

          const currentBreakpoint = new Screenmode().getCurrentBreakpoint()

          if (currentBreakpoint === 'xs' || currentBreakpoint === 'sm') {
            infoRequestOverlay
              .css('top', '0')
              .css('height', '100vh')
          } else {
            if ($(document).scrollTop() < that.options.scrollingHeaderTop[currentBreakpoint]) {
              infoRequestLayerTop = $(that.options.selectors.pageHeader).height() - $(document).scrollTop()

              infoRequestOverlay
                .css('top', infoRequestLayerTop + 'px')
                .css('height', 'calc(100vh - ' + infoRequestLayerTop + 'px)')
            }
          }
        }, 250)
      })
  }

  openInfoRequestOverlay () {
    const that = this
    const infoRequestOverlay = $(that.options.selectors.infoRequestOverlay)
    const currentBreakpoint = new Screenmode().getCurrentBreakpoint()
    let infoRequestLayerTop

    const body = $('body')

    $(that.options.selectors.mainNavigationClose)
      .trigger('click')

    body
      .removeClass(that.options.classes.bodyMobileNavigationOpen)
      .addClass(that.options.classes.bodyNoScroll)

    if (currentBreakpoint === 'xs' || currentBreakpoint === 'sm') {
      infoRequestOverlay
        .css('top', '')
        .css('height', '')
        .addClass(that.options.classes.infoRequestOverlayOpen)
    } else {
      if ($(document).scrollTop() < that.options.scrollingHeaderTop[currentBreakpoint]) {
        infoRequestLayerTop = $(that.options.selectors.pageHeader).height() - $(document).scrollTop()

        infoRequestOverlay
          .css('top', infoRequestLayerTop + 'px')
          .css('height', 'calc(100vh - ' + infoRequestLayerTop + 'px)')
      }

      infoRequestOverlay
        .addClass(that.options.classes.infoRequestOverlayOpen)
    }
  }

  closeInfoRequestOverlay () {
    const that = this

    $(that.options.selectors.infoRequestOverlay)
      .removeClass(that.options.classes.infoRequestOverlayOpen)

    $('body')
      .removeClass(that.options.classes.bodyNoScroll)
  }
}

export default InfoRequestOverlay
